module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/download-icon-primary-0fa847d8d549c2095740cbf2ebbfa2ed.svg&quot;;"